import React from 'react';
import { Check, X } from 'lucide-react';
export function TransformSection() {
  return <section className="py-20 px-4 bg-[#F2F1EE]" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        {/* Benefits */}
        <div className="text-center mb-20" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-12 text-[#DF1189]" data-id="element-213">
            Lo que cambia en tu semana
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-214">
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-215">
              <p className="text-4xl mb-4" data-id="element-216">😌</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-217">
                Menos estrés
              </h3>
              <p className="text-charcoal-light" data-id="element-218">
                Menos "¿qué hago hoy?" y menos picoteo por cansancio.
              </p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-219">
              <p className="text-4xl mb-4" data-id="element-220">💪</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-221">
                Más energía
              </h3>
              <p className="text-charcoal-light" data-id="element-222">
                Más proteína real sin sentirte a dieta estricta.
              </p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-223">
              <p className="text-4xl mb-4" data-id="element-224">🕊️</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-225">Más paz</h3>
              <p className="text-charcoal-light" data-id="element-226">
                Más control sin sentirte rígida. Tu comida deja de ser un
                problema.
              </p>
            </div>
          </div>
        </div>

        {/* Who is this for */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-227">
          {/* For You */}
          <div className="bg-olive/5 p-8 rounded-3xl border border-olive/10" data-id="element-228">
            <h3 className="text-2xl font-serif font-bold text-olive mb-6 flex items-center gap-3" data-id="element-229">
              <Check className="w-6 h-6" data-id="element-230" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-231">
              <li className="flex items-start gap-3" data-id="element-232">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-233" />
                <span className="text-charcoal" data-id="element-234">
                  Tienes freidora de aire (o planeas usarla)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-235">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-236" />
                <span className="text-charcoal" data-id="element-237">
                  Quieres comidas rápidas, repetibles y con sabor
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-238">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-239" />
                <span className="text-charcoal" data-id="element-240">
                  Te sirve seguir un menú y listas sin pensar
                </span>
              </li>
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-charcoal/5 p-8 rounded-3xl border border-charcoal/10" data-id="element-241">
            <h3 className="text-2xl font-serif font-bold text-charcoal-light mb-6 flex items-center gap-3" data-id="element-242">
              <X className="w-6 h-6" data-id="element-243" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-244">
              <li className="flex items-start gap-3" data-id="element-245">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-246" />
                <span className="text-charcoal-light" data-id="element-247">
                  Buscas cocina gourmet complicada
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-248">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-249" />
                <span className="text-charcoal-light" data-id="element-250">
                  Quieres recetas nuevas cada día
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-251">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-252" />
                <span className="text-charcoal-light" data-id="element-253">
                  No estás dispuesta a invertir 25 min dos veces por semana
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}